<template>
<span class="circle_button transition" :style="buttonStyle"></span>
</template>

<script>
export default {
  name: 'circle-button',

  props: {
    fill: Boolean,
    color: String,
    size: { type: [Number, String], default: 12 },
  },

  computed: {
    buttonStyle() {
      const backgroundColor = this.fill ? this.color : 'unset';
      return `
        border-color: ${this.fill ? 'black' : this.color};
        background-color: ${backgroundColor};
        min-height: ${this.size}px;
        min-width: ${this.size}px;
        height: ${this.size}px;
        width: ${this.size}px
      `;
    },
  },
};
</script>

<style>
.circle_button {
  border: solid 1px black;
  display: inline-block;
  border-radius: 50px;
  margin-left: auto;
  margin-right: auto;
}
</style>
